function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */
import _filter from 'lodash/filter';
import React from 'react';
import PropTypes from 'prop-types';
import SelectedGeneratorsCheckbox from 'js/containers/legacy/SelectedGeneratorsCheckbox';

var SelectedGenerators =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectedGenerators, _React$Component);

  function SelectedGenerators(props) {
    var _this;

    _classCallCheck(this, SelectedGenerators);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectedGenerators).call(this, props));
    _this.state = {
      expandedListMap: {}
    };
    return _this;
  }

  _createClass(SelectedGenerators, [{
    key: "checkboxListClasses",
    value: function checkboxListClasses(generatorType) {
      return "cndc-checkbox-list".concat(this.state.expandedListMap[generatorType] ? ' cndc-checkbox-list--open' : '');
    }
  }, {
    key: "toggleListExpandOnClickGenerator",
    value: function toggleListExpandOnClickGenerator(generatorType) {
      var _this2 = this;

      return function () {
        _this2.setState({
          expandedListMap: Object.assign({}, _this2.state.expandedListMap, _defineProperty({}, generatorType, !_this2.state.expandedListMap[generatorType]))
        });
      };
    }
  }, {
    key: "renderSelectedGeneratorCheckboxes",
    value: function renderSelectedGeneratorCheckboxes(generatorType) {
      var _this3 = this;

      var generatorTypeFilter = {
        type: generatorType
      };
      return _filter(this.props.plotParentGenerators, generatorTypeFilter).concat(_filter(this.props.plotChildGenerators, generatorTypeFilter)).map(function (generator, index) {
        return React.createElement(SelectedGeneratorsCheckbox, {
          plotId: _this3.props.plotId,
          key: "selected-generators-checkbox-".concat(_this3.props.plotId, "-").concat(generatorType, "-").concat(index),
          generatorId: generator.id
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return React.createElement("div", {
        className: "cndc-checkbox-list-wrapper"
      }, this.props.plotGeneratorTypes.map(function (generatorType) {
        return React.createElement("div", {
          className: _this4.checkboxListClasses(generatorType),
          key: "checkbox-list-".concat(_this4.props.plotId, "-").concat(generatorType)
        }, _this4.renderSelectedGeneratorCheckboxes(generatorType), _filter(_this4.props.plotChildGenerators, {
          type: generatorType
        }).length ? React.createElement("a", {
          href: "javascript:void(0)",
          onClick: _this4.toggleListExpandOnClickGenerator(generatorType)
        }, _this4.state.expandedListMap[generatorType] ? React.createElement("span", {
          className: "cndc-checkbox-list__expand-button cndc-checkbox-list__expand-button--contract"
        }) : React.createElement("span", {
          className: "cndc-checkbox-list__expand-button cndc-checkbox-list__expand-button--expand"
        })) : null);
      }));
    }
  }]);

  return SelectedGenerators;
}(React.Component);

SelectedGenerators.propTypes = {
  plotParentGenerators: PropTypes.array.isRequired,
  plotChildGenerators: PropTypes.array.isRequired,
  plotGeneratorTypes: PropTypes.array.isRequired,
  plotId: PropTypes.string.isRequired
};
export { SelectedGenerators as default };